import { Inject } from '../';
import { Constants, Order } from '../../Contract';
var CommandsWorker = (function () {
    function CommandsWorker(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject || Inject.Instance;
        this.invoker = this.inject.resolve(Constants.Invoker);
        this.commandFactory = this.inject.resolve(Constants.CommandFactory);
    }
    CommandsWorker.prototype.process = function (response) {
        var _this = this;
        if (response.viewDeltas && response.viewDeltas.Commands) {
            var msgArray_1 = [];
            response.viewDeltas.Commands.forEach(function (c) {
                if (c.Parameters && c.Parameters.Id === 'MSGBOX') {
                    msgArray_1.push(c);
                }
                else {
                    _this.invoker.invoke(_this.commandFactory.create(c));
                }
            });
            msgArray_1.reverse().forEach(function (c) {
                _this.invoker.invoke(_this.commandFactory.create(c));
            });
        }
    };
    Object.defineProperty(CommandsWorker.prototype, "Order", {
        get: function () {
            return Order.ORD;
        },
        enumerable: false,
        configurable: true
    });
    return CommandsWorker;
}());
export { CommandsWorker };
